import { useContext } from 'react';
import { PatientContext, PatientContextValue } from '../contexts/PatientContext';

/**
 * 患者選択状態を取得するカスタムフック
 *
 * @returns PatientContextValue - 患者選択状態と操作関数
 * @throws Error - PatientProvider外で使用された場合
 *
 * @example
 * ```tsx
 * const {
 *   selectedPatientId,
 *   selectedPatient,
 *   linkedPatients,
 *   isLoading,
 *   selectPatient,
 * } = usePatient();
 *
 * // 患者切り替え
 * selectPatient(123);
 * ```
 */
export function usePatient(): PatientContextValue {
  const context = useContext(PatientContext);

  if (context === undefined) {
    throw new Error('usePatient must be used within a PatientProvider');
  }

  return context;
}

export default usePatient;
